import { useTheme } from '@mui/material';
import { Label } from 'components';
import { UserTypology } from 'helpers/Enums';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';

interface IProps {
    isPublic: boolean
    source: UserTypology
}

let MessageStatus = ({ isPublic, source }: IProps) => {
    let { palette } = useTheme();
    let { formatMessage } = useIntl();

    return (
        <>
            {source === "System" &&
                <Label color={palette.grey[500]} variant="outlined">
                    <span>{formatMessage({ id: LocalizationIds.SystemMessage })}</span>
                </Label>
            }
            {source === "Simec" &&
                <Label color={isPublic === true ? palette.success.main : palette.error.main} variant="outlined">
                    {isPublic === true
                        ? <span>{formatMessage({ id: LocalizationIds.SharedWithCustomer })}</span>
                        : <span>{formatMessage({ id: LocalizationIds.NotSharedWithCustomer })}</span>
                    }
                </Label>
            }
            {source === "Customer" &&
                <Label color={palette.primary.main} variant="outlined">
                    {formatMessage({ id: LocalizationIds.MessageFromCustomer })}
                </Label>
            }
        </>
    )
}

export default MessageStatus;